export const angleSortFunction = (a, b) => {
  const varA = parseInt(a);
  const varB = parseInt(b);

  if (varA > varB) {
    return 1;
  }

  if (varA < varB) {
    return -1;
  }

  return 0;
};

export function sortObjectArrayByAngle(arr, key = 'code') {
  return arr.sort((a, b) => angleSortFunction(a[key], b[key]));
}
